export default __webpack_public_path__ + "static/media/case_study_mcdonalds_cover.5ece25b5.jpg";